import { IonCol, IonGrid, IonImg, IonRow } from '@ionic/react';

import SuccessIllustration from '@/assets/illustrations/SuccessIllustration.svg';

import styles from './CalibrationCompleted.module.css';

interface CalibrationCompletedProps {
  title: string;
  description: string;
}

export const CalibrationCompleted = ({ title, description }: CalibrationCompletedProps) => {
  return (
    <IonGrid>
      <IonRow className='ion-align-items-center'>
        <IonCol className='ion-align-items-center ion-text-center'>
          <IonImg
            alt='Stylized checkmark made of six green dots in a curved, upward motion, centered within a large off-white circle.'
            className={styles.illustration}
            src={SuccessIllustration}
          />
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.description}>{description}</p>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};
